import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import seoData from '../seo/about.json';

export default function About() {
  const values = [
    { title: 'Punctuality', desc: 'We arrive early, every time. Your schedule is our priority and we never keep you waiting.' },
    { title: 'Discretion', desc: 'Professional, confidential service. What happens in the ride stays in the ride.' },
    { title: 'Immaculate Fleet', desc: 'Every vehicle is detailed before each ride. You\'ll always step into a spotless, pristine interior.' },
    { title: 'Local Expertise', desc: 'We know Los Angeles inside out — every shortcut, every back road, and the best routes at any hour.' },
  ];

  return (
    <>
      <SEOHead seo={seoData} />

      <section className="page-header">
        <div className="container">
          <div className="section-label">Our Story</div>
          <h1>About <em>Us</em></h1>
          <div className="gold-line" />
          <p>
            Professional chauffeurs dedicated to delivering the finest luxury
            transportation experience in Los Angeles.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="about-grid">
            <div className="about-text">
              <div className="section-label">Who We Are</div>
              <h2 className="section-title" style={{ fontSize: 'clamp(1.8rem, 4vw, 2.8rem)' }}>
                Premium Service,<br />Personal Touch
              </h2>
              <p>
                LuxuryCarLA was founded on a simple belief: luxury transportation in
                Los Angeles should be effortless, elegant, and reliable. We're not a
                faceless corporation — we're professional drivers who take immense pride
                in every ride.
              </p>
              <p>
                Our driver personally operates every vehicle in our fleet, ensuring
                consistent quality and a personal connection with every client. Whether
                it's a quick airport run or an all-day charter, you get the same
                five-star experience every time.
              </p>

              <div className="about-stats">
                <div className="about-stat">
                  <div className="about-stat-number">24/7</div>
                  <div className="about-stat-label">Availability</div>
                </div>
                <div className="about-stat">
                  <div className="about-stat-number">100%</div>
                  <div className="about-stat-label">Satisfaction</div>
                </div>
                <div className="about-stat">
                  <div className="about-stat-number">LA</div>
                  <div className="about-stat-label">Based & Operated</div>
                </div>
                <div className="about-stat">
                  <div className="about-stat-number">2</div>
                  <div className="about-stat-label">Phone Lines</div>
                </div>
              </div>
            </div>

            <div className="about-image-wrapper">
              <img
                src="https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=800&q=80&auto=format"
                alt="Professional chauffeur with luxury black car"
                loading="lazy"
              />
              <div className="about-image-glow" />
            </div>
          </div>
        </div>
      </section>

      <section className="section" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: 0 }}>
            <div className="section-label">Our Principles</div>
            <h2 className="section-title">What Sets Us Apart</h2>
          </div>
          <div className="values-grid">
            {values.map((v, i) => (
              <div className="value-card" key={i}>
                <div className="value-number">{String(i + 1).padStart(2, '0')}</div>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-banner">
        <div className="container">
          <h2>Experience the Difference</h2>
          <p>Book a ride and see why our clients keep coming back.</p>
          <div className="cta-actions">
            <a href="tel:8189154566" className="btn-primary">Call (818) 915-4566</a>
            <Link to="/contact" className="btn-outline">Get In Touch</Link>
          </div>
        </div>
      </section>
    </>
  );
}
